var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"designNumber-container"},_vm._l((_vm.NumberList),function(item,index){return _c('svg-icon',{key:index,staticClass:"svg-icon",style:(_vm.numObj.numStyle),attrs:{"icon-class":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }